
function UserSVG({ width, height }) {
  return (
    <svg width={width || 32} height={height || 31} viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.1907 14.6737C19.9366 14.6737 22.9732 11.6328 22.9732 7.88155C22.9732 4.13032 19.9366 1.08936 16.1907 1.08936C12.4448 1.08936 9.4082 4.13032 9.4082 7.88155C9.4082 11.6328 12.4448 14.6737 16.1907 14.6737Z" stroke="white" strokeWidth="2.10213" strokeMiterlimit="10"/>
      <path d="M2 17.8427L16.1894 15.0577L30.3787 17.8427C30.3787 22.2477 24.0219 29.5088 16.1894 29.5088C8.35683 29.5088 2 22.2477 2 17.8427Z" stroke="white" strokeWidth="2.10213" strokeMiterlimit="10"/>
    </svg>
  )
}

export { UserSVG }